/* eslint-disable import/prefer-default-export */
export enum CampaignError {
  ValidationError = 'Validation Error',
  InvalidLink = 'Invalid Link',
  IneligibleUser = 'Ineligible User',
  OtherError = 'Other Error',
}
